<template>
  <Modal @close="handleCloseModal" v-if="isShowModal">
    <template #point>
      <i class="icon icon-point-toast icon-toast"></i>
    </template>
    <template #body>
      <h4 class="modal-point-icon">{{ getComma(point) }}</h4>
      <p class="modal-point-description">
        ポイントを<br>
        {{ pointMessage }}
      </p>
    </template>
  </Modal>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import getComma from '@/filters/comma';
import Modal from '@/components/Modal.vue';

const props = defineProps({
  point: {
    type: Number,
    required: true,
  },
  isPayment: {
    type: Boolean,
    default: false,
  },
  isShowModal: {
    type: Boolean,
    default: false,
  },
  handleCloseModal: {
    type: Function,
    required: true,
  },
});

const pointMessage = computed(() => (props?.isPayment ? '消費しました' : '獲得しました'));
</script>

<style scoped>
.modal-point-icon {
  font-size: 40px;
  color: #1d1d1d;
  font-weight: bold;
  font-family: "Helvetica";
  text-align: center;
}

.icon-toast {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
}

.modal-description {
  font-size: 18px;
  line-height: 27px;
  color: #1d1d1d;
  font-family: "Hira Kaku Pro N";
  text-align: center;
}
</style>
